@if (showSpinner) {
  <app-loader> </app-loader>
}
<div class="main-common-wrapper">
  <div class="inner-comon-wrapper">
    <div class="comon-small-wrapper border pt-4 pb-4">
      <h5 class="pl-4 pr-4">Notifications <span (click)="clearnotify()">Mark all as read</span></h5>
      <div class="tabs-header-main pl-3 pr-3">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button class="nav-link" [class.active]="selectedTab === 'all'" id="nav-all-tab" type="button"
          role="tab" (click)="switchTab('all')">All</button>
          @if (showAdmintab && filteredleaves.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'leave'" id="nav-leave-tab" type="button"
            role="tab" (click)="switchTab('leave')">Leave Requests</button>
          }
          @if (showAdmintab && filteredAttendance.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'attendance'" id="nav-attendance-tab" type="button"
            role="tab" (click)="switchTab('attendance')">Attendance Corrections</button>
          }
          @if (showAdmintab && filteredLoans.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'loan'" id="nav-loan-tab" type="button"
            role="tab" (click)="switchTab('loan')">Loan Requests</button>
          }
           @if (showAdmintab && filteredPayroll.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'payroll'" id="nav-payroll-tab" type="button"
            role="tab" (click)="switchTab('payroll')">PayRoll Requests</button>
          }



          <!-- employe side -->
          @if (EmployeeTab && filteredApprovals.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'approval'" id="nav-approval-tab"
              type="button" role="tab" (click)="switchTab('approval')">Approvals</button>
          }
          @if (EmployeeTab && filteredRejections.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'rejection'" id="nav-rejection-tab"
              type="button" role="tab" (click)="switchTab('rejection')">Rejections</button>
          }
          @if (EmployeeTab && filteredUpdations.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'updation'" id="nav-updation-tab"
              type="button" role="tab" (click)="switchTab('updation')">Updates</button>
          }
          @if (EmployeeTab && filteredAnnouncements.length > 0) {
            <button class="nav-link" [class.active]="selectedTab === 'announcement'" id="nav-announcement-tab"
              type="button" role="tab" (click)="switchTab('announcement')">Announcements</button>
          }

        </div>
      </div>
      <div class="tabs-body-main">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade" [class.active]="selectedTab === 'all'" [class.show]="selectedTab === 'all'" id="nav-all" role="tabpanel" aria-labelledby="nav-all-tab">
            @for (data of notifyData; track data) {
              @if (data.req_type === 'Leave Request') {
                <div class="main-wrapper notify-margin"
                  [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                  >
                  <div class="notify-content-main-in-wrapper content-display " [routerLink]="['/show-leaves']"
                    (click)="clearnotifications(data.req_notifications[0].notification_id)">
                    <div class="notify-content-left">
                      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                    </div>
                    <div class="notify-content-right">
                      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                      <h1>{{data.req_type}}</h1>
                      <p>{{ formatDate(parseJson(data.data).date) }}</p>
                      <div class="notify-inner-sec">
                        <h4>
                          <span>{{ parseJson(data.data).sender_user.first_name }} {{
                          parseJson(data.data).sender_user.last_name }}</span>
                          has requested <span>{{ parseJson(data.data).title[0] }}</span> on {{
                          formatOnlyDate(parseJson(data.data).date) }}.
                        </h4>
                      </div>
                      @if (data.leave?.leavenotify[0]?.status == '1') {
                        <p class="approve-label">
                          <span class="span-color-approve-label"> Action Is Alreadyy Performed.</span>
                        </p>
                      }
                    </div>
                    @if ( data.req_notifications[0].is_read == 0) {
                      <div class="acive-section">
                        <div class="div-cirlce">
                        </div>
                      </div>
                    }
                  </div>
                  @if (data.leave && (data.leave.status === 'pending' || data.leave.leavenotify[0].status == '0')) {
                    <div class="notify-action-button"
                      >
                      @if (leaveReject && activeRejectId != parseJson(data.data).type_id || isavailablefeatureforLeave('isReject')) {
                        <div class="notify-button reject-action-btn"
                          (click)="toggleRejectBox(parseJson(data.data).type_id)">
                          Reject
                        </div>
                      }
                      @if (leaveaccept  && activeRejectId != parseJson(data.data).type_id || isavailablefeatureforLeave('isAccept')) {
                        <div class="notify-button accept-action-btn"
                          (click)="approveleave(data)">
                          {{getApprovalButtonLabel(data.leave)}}
                        </div>
                      }
                      @if (activeRejectId == parseJson(data.data).type_id) {
                        <div class="col-12 mt-2 mb-2 text-box">
                          <textarea class="form-control" id="rejected_reason" rows="3" name="rejected_reason"
                            placeholder="Enter Reason" [(ngModel)]="rejectedReason" #r="ngModel" required>
                          </textarea>
                          @if (rejectedReason &&  rejectedReason.length < 50) {
                            <div class="alert alert-warning mt-2">
                              Ensure that the entered <strong>Reason</strong> contains minimum of 50 characters.
                            </div>
                          }
                          @if (leaveRejectionData.length > 0) {
                            <div class="mt-4">
                              @for (item of leaveRejectionData; track item) {
                                <div>
                                  <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                                </div>
                              }
                            </div>
                          }
                          <div class="mt-3 d-flex justify-content-between">
                            <button class="notify-button accept-action-btn" [disabled]=" rejectedReason.length < 50"
                              (click)="reject()">
                              Submit Rejection
                            </button>
                            <button class="notify-button reject-action-btn"
                            (click)="toggleRejectBox(parseJson(data.data).type_id)">Cancel</button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (data.req_type === 'Leave Request Edited') {
                <div class="notify-content-main content-display notify-margin "
                  [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                  [routerLink]="['/show-leaves']"
                  (click)="clearnotifications(data.req_notifications[0].notification_id)">
                  <div class="notify-content-left">
                    <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                  </div>
                  <div class="notify-content-right">
                    <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                    <h1>{{data.req_type}}</h1>
                    <p>{{ formatDate(parseJson(data.data).date) }}</p>
                    <div class="notify-inner-sec">
                      <h4>
                        <span>{{ parseJson(data.data).sender_user.first_name }} {{
                        parseJson(data.data).sender_user.last_name }}</span>
                        has Edited <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
                        formatOnlyDate(parseJson(data.data).date) }}.
                      </h4>
                    </div>
                  </div>
                  @if ( data.req_notifications[0].is_read == 0) {
                    <div class="active-section">
                      <div class="div-cirlce">
                      </div>
                    </div>
                  }
                </div>
              }
              @if (data.req_type === 'Leave Request Deleted') {
                <div class="notify-content-main content-display notify-margin "
                  [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                  [routerLink]="['/show-leaves']"
                  (click)="clearnotifications(data.req_notifications[0].notification_id)">
                  <div class="notify-content-left">
                    <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                  </div>
                  <div class="notify-content-right">
                    <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                    <h1>{{data.req_type}}</h1>
                    <p>{{ formatDate(parseJson(data.data).date) }}</p>
                    <div class="notify-inner-sec">
                      <h4>
                        <span>{{ parseJson(data.data).sender_user.first_name }} {{
                        parseJson(data.data).sender_user.last_name }}</span>
                        has Deleted <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
                        formatOnlyDate(parseJson(data.data).date) }}.
                      </h4>
                    </div>
                  </div>
                  @if ( data.req_notifications[0].is_read == 0) {
                    <div class="active-section">
                      <div class="div-cirlce">
                      </div>
                    </div>
                  }
                </div>
              }
              @if (data.req_type === 'Approve Leave' && showAdmintab) {
                <div class="notify-content-main content-display notify-margin"
                  [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                  (click)="clearnotifications(data.req_notifications[0].notification_id)" [routerLink]="['/show-leaves']">
                  <div class="notify-content-left">
                    <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                    <div class="action-circle">
                      <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                    </div>
                  </div>
                  <div class="notify-content-right">
                    <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                    <h1>{{data.req_type}}</h1>
                    <p>{{ formatDate(parseJson(data.data).date) }}</p>
                    <div class="notify-inner-sec">
                      <h4>
                        <span>{{ parseJson(data.data).sender_user.first_name }} {{
                        parseJson(data.data).sender_user.last_name }}</span>
                        had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
                      }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
                    </h4>
                  </div>
                </div>
                @if ( data.req_notifications[0].is_read == 0) {
                  <div class="active-section">
                    <div class="div-cirlce">
                    </div>
                  </div>
                }
              </div>
            }
            @if (['Approve Leave'].includes(data.req_type) && EmployeeTab) {
              <div class="notify-content-main content-display notify-margin"
                [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                (click)="clearnotifications(data.req_notifications[0].notification_id)"
                [routerLink]="['/user-leaves-view']">
                <div class="notify-content-left">
                  <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                  <div class="action-circle">
                    <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
                  </div>
                </div>
                <div class="notify-content-right">
                  <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                  <h1>{{data.req_type}}</h1>
                  <p>{{ formatDate(parseJson(data.data).date) }}</p>
                  <div class="notify-inner-sec">
                    <h4>
                      <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                      had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                      formatOnlyDate(parseJson(data.data).date) }}.
                    </h4>
                  </div>
                </div>
                @if ( data.req_notifications[0].is_read == 0) {
                  <div class="active-section">
                    <div class="div-cirlce">
                    </div>
                  </div>
                }
              </div>
            }
            @if (data.req_type === 'Rejected Leave' && showAdmintab) {
              <div class="notify-content-main content-display notify-margin"
                [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
                [routerLink]="['/show-leaves']"
                (click)="clearnotifications(data.req_notifications[0].notification_id)">
                <div class="notify-content-left">
                  <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                  <div class="action-circle">
                    <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                  </div>
                </div>
                <div class="notify-content-right">
                  <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                  <h1>{{data.req_type}}</h1>
                  <p>{{ formatDate(parseJson(data.data).date) }}</p>
                  <div class="notify-inner-sec">
                    <h4>
                      <span>{{ parseJson(data.data).sender_user.first_name }} {{
                      parseJson(data.data).sender_user.last_name }}</span>
                      had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
                    }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.{{"muna bhai"}}
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
                <div class="active-section">
                  <div class="div-cirlce">
                  </div>
                </div>
              }
            </div>
          }
          @if (['Rejected Leave'].includes(data.req_type) && EmployeeTab) {
            <div class="notify-content-main content-display notify-margin"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/user-leaves-view']"
              (click)="clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
                <div class="action-circle">
                  <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
                </div>
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                    parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                    formatOnlyDate(parseJson(data.data).date) }}.
                  </h4>
                </div>
              </div>
              @if ( data.req_notifications[0].is_read == 0) {
                <div class="active-section">
                  <div class="div-cirlce">
                  </div>
                </div>
              }
            </div>
          }
          @if (['Updated Leave'].includes(data.req_type) && showAdmintab) {
            <div class="notify-content-main content-display notify-margin"
              [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
              [routerLink]="['/show-leaves']"
              (click)="clearnotifications(data.req_notifications[0].notification_id)">
              <div class="notify-content-left">
                <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              </div>
              <div class="notify-content-right">
                <!-- <h1>{{parseJson(data.data).title}}</h1> -->
                <h1>{{data.req_type}}</h1>
                <p>{{ formatDate(parseJson(data.data).date) }}</p>
                <div class="notify-inner-sec">
                  <h4>
                    <span>{{ parseJson(data.data).sender_user.first_name }} {{
                    parseJson(data.data).sender_user.last_name }}</span>
                    had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
                  }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.{{"muna abahi 22"}}
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Updated Leave'].includes(data.req_type) && EmployeeTab) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-leaves-view']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  had <span>{{ parseJson(data.data).title[0] }}</span> on {{
                  formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        <!-- Attendance  -->
        @if (['Attendance Correction' ].includes(data.req_type)) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-attendance-list']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has request for
                  @if (parseJson(data.data).title === 'check_in') {
                    <span>Pounch In</span>
                  }
                  @if (parseJson(data.data).title === 'check_out') {
                    <span>Pounch Out</span>
                  }
                  @if (parseJson(data.data).title === 'overtime') {
                    <span>Over Time</span>
                  }
                  on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Approved Attendance' ].includes(data.req_type) && showAdmintab) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-attendance-list']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              <div class="action-circle">
                <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
              </div>
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has {{ parseJson(data.data).title[0] }} request of {{ parseJson(data.data).title[1] }}
                  on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Approved Attendance' ].includes(data.req_type) && EmployeeTab ) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-attendance']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              <div class="action-circle">
                <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
              </div>
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has {{ parseJson(data.data).title[0] }} request
                  on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Rejected Attendance' ].includes(data.req_type) && showAdmintab) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-attendance-list']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              <div class="action-circle">
                <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
              </div>
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has {{ parseJson(data.data).title[0] }} request of {{ parseJson(data.data).title[1] }}
                  on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Rejected Attendance' ].includes(data.req_type) && EmployeeTab ) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/user-attendance']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
              <div class="action-circle">
                <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
              </div>
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has {{ parseJson(data.data).title[0] }} request
                  on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        <!-- Loan -->
        @if (['Loan Request' ].includes(data.req_type)) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/loan-report']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has request for
                  <span>{{parseJson(data.data).title}}</span>
                 /- Pkr loan on {{ formatOnlyDate(parseJson(data.data).date) }}.
                </h4>
              </div>
            </div>
            @if ( data.req_notifications[0].is_read == 0) {
              <div class="active-section">
                <div class="div-cirlce">
                </div>
              </div>
            }
          </div>
        }
        @if (['Loan Request Edited' ].includes(data.req_type)) {
          <div class="notify-content-main content-display notify-margin"
            [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
            [routerLink]="['/loan-report']"
            (click)="clearnotifications(data.req_notifications[0].notification_id)">
            <div class="notify-content-left">
              <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
            </div>
            <div class="notify-content-right">
              <!-- <h1>{{parseJson(data.data).title}}</h1> -->
              <h1>{{data.req_type}}</h1>
              <p>{{ formatDate(parseJson(data.data).date) }}</p>
              <div class="notify-inner-sec">
                <h4>
                  <span>{{ parseJson(data.data).sender_user.first_name }} {{
                  parseJson(data.data).sender_user.last_name }}</span>
                  has Edited Amount from
                  <span>{{ parseJson(data.data).title.split(',')[0] }}</span> to <span>{{
                parseJson(data.data).title.split(',')[2] }}</span>
                Duration from
                <span>{{ parseJson(data.data).title.split(',')[1] }} Month</span> to <span>{{
              parseJson(data.data).title.split(',')[3] }} Month</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Loan Request Deleted' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/loan-report']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Deleted Loan request
              <span>{{ parseJson(data.data).title }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Approved Loan'].includes(data.req_type) && showAdmintab) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/loan-report']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
            }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
          </h4>
        </div>
      </div>
      @if ( data.req_notifications[0].is_read == 0) {
        <div class="active-section">
          <div class="div-cirlce">
          </div>
        </div>
      }
    </div>
  }
  @if (['Approved Loan'].includes(data.req_type) && EmployeeTab) {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/payroll']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        <div class="action-circle">
          <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
        </div>
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had <span>{{ parseJson(data.data).title[0] }}</span> on {{
            formatOnlyDate(parseJson(data.data).date) }}.
          </h4>
        </div>
      </div>
      @if ( data.req_notifications[0].is_read == 0) {
        <div class="active-section">
          <div class="div-cirlce">
          </div>
        </div>
      }
    </div>
  }
  @if (['Rejected Loan'].includes(data.req_type) && showAdmintab) {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/loan-report']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        <div class="action-circle">
          <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
        </div>
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
          }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Rejected Loan'].includes(data.req_type) && EmployeeTab) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/payroll']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          had <span>{{ parseJson(data.data).title[0] }}</span> on {{
          formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}

<!-- payroll -->

  @if (['Payroll Review Request'].includes(data.req_type) && showAdmintab) {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/payroll-summary']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had send you <span>{{ parseJson(data.data).title }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Payroll Change Requested'].includes(data.req_type) && showAdmintab) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/payroll-summary']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
          had send you <span>{{ parseJson(data.data).title }}</span> on {{
          formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Payroll Approved'].includes(data.req_type) && showAdmintab) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/payroll-summary']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
          had send you <span>{{ parseJson(data.data).title }}</span> on {{
          formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}



<!-- Policy -->
@if (['Policy Added' ].includes(data.req_type)) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/company-policy']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          has Add a Policy
          <span>{{ parseJson(data.data).title }}</span>
          on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Policy Edit' ].includes(data.req_type)) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/company-policy']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          has Edit a Policy
          <span>{{ parseJson(data.data).title }}</span>
          on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Policy Deleted' ].includes(data.req_type)) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/company-policy']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          has Edit a Policy
          <span>{{ parseJson(data.data).title }}</span>
          on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}







}
</div>
<div class="tab-pane fade" [class.active]="selectedTab === 'leave'" [class.show]="selectedTab === 'leave'" id="nav-leave" role="tabpanel" aria-labelledby="nav-leave-tab">
  @for (data of filteredleaves; track data) {
    @if (data.req_type === 'Leave Request') {
      <div class="main-wrapper notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        >
        <div class="notify-content-main-in-wrapper content-display" [routerLink]="['/show-leaves']"
          (click)="clearnotifications(data.req_notifications[0].notification_id)">
          <div class="notify-content-left">
            <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          </div>
          <div class="notify-content-right">
            <!-- <h1>{{parseJson(data.data).title}}</h1> -->
            <h1>{{data.req_type}}</h1>
            <p>{{ formatDate(parseJson(data.data).date) }}</p>
            <div class="notify-inner-sec">
              <h4>
                <span>{{ parseJson(data.data).sender_user.first_name }} {{
                parseJson(data.data).sender_user.last_name }}</span>
                has requested <span>{{ parseJson(data.data).title }}</span> on {{
                formatOnlyDate(parseJson(data.data).date) }}.
              </h4>
            </div>
            @if (data.leave && data.leave.leavenotify[0].status == '1') {
              <p class="approve-label">
                <span class="span-color-approve-label"> Action Is Alreadyy Performed.</span>
              </p>
            }
          </div>
          @if ( data.req_notifications[0].is_read == 0) {
            <div class="active-section">
              <div class="div-cirlce">
              </div>
            </div>
          }
        </div>
        @if (data.leave && (data.leave.status === 'pending' || data.leave.leavenotify[0].status == '0')) {
          <div class="notify-action-button"
            >
            @if (leaveReject && activeRejectId != parseJson(data.data).type_id || isavailablefeatureforLeave('isReject')) {
              <div class="notify-button reject-action-btn"
                (click)="toggleRejectBox(parseJson(data.data).type_id)">
                Reject
              </div>
            }
            @if (leaveaccept  && activeRejectId != parseJson(data.data).type_id || isavailablefeatureforLeave('isAccept')) {
              <div class="notify-button accept-action-btn"
                (click)="approveleave(data)">
                Accept
              </div>
            }
            @if (activeRejectId == parseJson(data.data).type_id) {
              <div class="col-12 mt-2 mb-2 text-box">
                <textarea class="form-control" id="rejected_reason" rows="3" name="rejected_reason"
                  placeholder="Enter Reason" [(ngModel)]="rejectedReason" #r="ngModel" required>
                </textarea>
                @if (rejectedReason &&  rejectedReason.length < 50) {
                  <div class="alert alert-warning mt-2">
                    Ensure that the entered <strong>Reason</strong> contains minimum of 50 characters.
                  </div>
                }
                @if (leaveRejectionData.length > 0) {
                  <div class="mt-4">
                    @for (item of leaveRejectionData; track item) {
                      <div>
                        <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                      </div>
                    }
                  </div>
                }
                <div class="mt-3 d-flex justify-content-between">
                  <button class="notify-button accept-action-btn" [disabled]=" rejectedReason.length < 50"
                    (click)="reject()">
                    Submit Rejection
                  </button>
                  <button class="notify-button reject-action-btn"
                  (click)="toggleRejectBox(parseJson(data.data).type_id)">Cancel</button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (data.req_type === 'Leave Request Edited') {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/show-leaves']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Edited <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
              formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (data.req_type === 'Leave Request Deleted') {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/show-leaves']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Deleted <span>{{ parseJson(data.data).title.split(',')[1] }}</span> on {{
              formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (data.req_type === 'Rejected Leave') {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/show-leaves']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
            }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
          </h4>
        </div>
      </div>
      @if ( data.req_notifications[0].is_read == 0) {
        <div class="active-section">
          <div class="div-cirlce">
          </div>
        </div>
      }
    </div>
  }
  @if (data.req_type === 'Approve Leave') {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/show-leaves']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        <div class="action-circle">
          <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
        </div>
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
          }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (data.req_type === 'Updated Leave') {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          had <span>{{ parseJson(data.data).title[0] }}</span> on {{
          formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
}
</div>
<div class="tab-pane fade" [class.active]="selectedTab === 'attendance'" [class.show]="selectedTab === 'attendance'" id="nav-attendance" role="tabpanel" aria-labelledby="nav-attendance-tab">
  @for (data of filteredAttendance; track data) {
    @if (data.req_type === 'Attendance Correction') {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/user-attendance-list']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has request for
              @if (parseJson(data.data).title === 'check_in') {
                <span>Pounch In</span>
              }
              @if (parseJson(data.data).title === 'check_out') {
                <span>Pounch Out</span>
              }
              @if (parseJson(data.data).title === 'overtime') {
                <span>Over Time</span>
              }
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Approved Attendance' ].includes(data.req_type) && EmployeeTab ) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/user-attendance']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has {{ parseJson(data.data).title[0] }} request
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Rejected Attendance' ].includes(data.req_type) && EmployeeTab ) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/user-attendance']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has {{ parseJson(data.data).title[0] }} request
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
  }
</div>
<div class="tab-pane fade" [class.active]="selectedTab === 'loan'" [class.show]="selectedTab === 'loan'" id="nav-loan" role="tabpanel" aria-labelledby="nav-loan-tab">
  @for (data of filteredLoans; track data) {
    <!-- Loan -->
    @if (['Loan Request' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/loan-report']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has request for
              <span>{{parseJson(data.data).title}}</span>
              /- Pkr loan on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Loan Request Edited' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/loan-report']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Edited Amount from
              <span>{{ parseJson(data.data).title.split(',')[0] }}</span> to <span>{{
            parseJson(data.data).title.split(',')[2] }}</span>
            Duration from
            <span>{{ parseJson(data.data).title.split(',')[1] }} Month</span> to <span>{{
          parseJson(data.data).title.split(',')[3] }} Month</span>
          on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Loan Request Deleted' ].includes(data.req_type)) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/loan-report']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          has Deleted Loan request
          <span>{{ parseJson(data.data).title }}</span>
          on {{ formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Approved Loan'].includes(data.req_type) && showAdmintab) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/loan-report']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
        }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
      </h4>
    </div>
  </div>
  @if ( data.req_notifications[0].is_read == 0) {
    <div class="active-section">
      <div class="div-cirlce">
      </div>
    </div>
  }
</div>
}
@if (['Approved Loan'].includes(data.req_type) && EmployeeTab) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/payroll']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          had <span>{{ parseJson(data.data).title[0] }}</span> on {{
          formatOnlyDate(parseJson(data.data).date) }}.
        </h4>
      </div>
    </div>
    @if ( data.req_notifications[0].is_read == 0) {
      <div class="active-section">
        <div class="div-cirlce">
        </div>
      </div>
    }
  </div>
}
@if (['Rejected Loan'].includes(data.req_type)) {
  <div class="notify-content-main content-display notify-margin"
    [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
    [routerLink]="['/loan-report']"
    (click)="clearnotifications(data.req_notifications[0].notification_id)">
    <div class="notify-content-left">
      <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      <div class="action-circle">
        <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
      </div>
    </div>
    <div class="notify-content-right">
      <!-- <h1>{{parseJson(data.data).title}}</h1> -->
      <h1>{{data.req_type}}</h1>
      <p>{{ formatDate(parseJson(data.data).date) }}</p>
      <div class="notify-inner-sec">
        <h4>
          <span>{{ parseJson(data.data).sender_user.first_name }} {{
          parseJson(data.data).sender_user.last_name }}</span>
          had <span>{{ parseJson(data.data).title[0] }}</span> of <span>{{ parseJson(data.data).title[1]
        }}</span> on {{ formatOnlyDate(parseJson(data.data).date) }}.
      </h4>
    </div>
  </div>
  @if ( data.req_notifications[0].is_read == 0) {
    <div class="active-section">
      <div class="div-cirlce">
      </div>
    </div>
  }
</div>
}
}
</div>

<!-- payroll -->


<div class="tab-pane fade" [class.active]="selectedTab === 'payroll'" [class.show]="selectedTab === 'payroll'" id="nav-payroll" role="tabpanel" aria-labelledby="nav-payroll-tab">
  @for (data of filteredPayroll; track data) {
    <!-- Loan -->
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/payroll-summary']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data)?.sender_user?.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has request for
              <span>{{parseJson(data.data).title}}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    
}
</div>


<!-- employee tabs -->

<div class="tab-pane fade" [class.active]="selectedTab === 'announcement'" [class.show]="selectedTab === 'announcement'" id="nav-announcement" role="tabpanel" aria-labelledby="nav-announcement-tab">
  @for (data of filteredPolicy; track data) {
    <!-- Policy -->
    @if (['Policy Added' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/company-policy']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <h1>{{parseJson(data.data).title}}</h1>
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Add a Policy
              <span>{{ parseJson(data.data).title }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Policy Edit' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/company-policy']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Edit a Policy
              <span>{{ parseJson(data.data).title }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Policy Deleted' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/company-policy']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              has Edit a Policy
              <span>{{ parseJson(data.data).title }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Approve Leave' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [routerLink]="['/user-leaves-view']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had
              <span>{{ parseJson(data.data).title[0] }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
  }
</div>



<div class="tab-pane fade" [class.active]="selectedTab === 'approval'" [class.show]="selectedTab === 'approval'" id="nav-approval" role="tabpanel" aria-labelledby="nav-approval-tab">
  @for (data of filteredApprovals; track data) {
    @if (['Approve Leave' ].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/user-leaves-view']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had
              <span>{{ parseJson(data.data).title[0] }}</span>
              on {{ formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
    @if (['Approved Loan'].includes(data.req_type)) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/payroll']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/tick.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had <span>{{ parseJson(data.data).title[0] }}</span> on {{
              formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
  }
</div>


<div class="tab-pane fade" [class.active]="selectedTab === 'rejection'" [class.show]="selectedTab === 'rejection'" id="nav-rejection" role="tabpanel" aria-labelledby="nav-rejection-tab">
  @for (data of filteredRejections; track data) {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/user-leaves-view']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
        <div class="action-circle">
          <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
        </div>
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had <span>{{ parseJson(data.data).title[0] }}</span> on {{
            formatOnlyDate(parseJson(data.data).date) }}.
          </h4>
        </div>
      </div>
      @if ( data.req_notifications[0].is_read == 0) {
        <div class="active-section">
          <div class="div-cirlce">
          </div>
        </div>
      }
    </div>
    @if (['Rejected Loan'].includes(data.req_type) ) {
      <div class="notify-content-main content-display notify-margin"
        [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
        [routerLink]="['/payroll']"
        (click)="clearnotifications(data.req_notifications[0].notification_id)">
        <div class="notify-content-left">
          <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
          <div class="action-circle">
            <img src="../../../../assets/theme1/coss.png" alt="Profile Image" />
          </div>
        </div>
        <div class="notify-content-right">
          <!-- <h1>{{parseJson(data.data).title}}</h1> -->
          <h1>{{data.req_type}}</h1>
          <p>{{ formatDate(parseJson(data.data).date) }}</p>
          <div class="notify-inner-sec">
            <h4>
              <span>{{ parseJson(data.data).sender_user.first_name }} {{
              parseJson(data.data).sender_user.last_name }}</span>
              had <span>{{ parseJson(data.data).title[0] }}</span> on {{
              formatOnlyDate(parseJson(data.data).date) }}.
            </h4>
          </div>
        </div>
        @if ( data.req_notifications[0].is_read == 0) {
          <div class="active-section">
            <div class="div-cirlce">
            </div>
          </div>
        }
      </div>
    }
  }
</div>

<div class="tab-pane fade" [class.active]="selectedTab === 'updation'" [class.show]="selectedTab === 'updation'" id="nav-updation" role="tabpanel" aria-labelledby="nav-updation-tab">
  @for (data of filteredUpdations; track data) {
    <div class="notify-content-main content-display notify-margin"
      [ngClass]="{ 'notify-active': data.req_notifications[0].is_read == 0 }"
      [routerLink]="['/user-leaves-view']"
      (click)="clearnotifications(data.req_notifications[0].notification_id)">
      <div class="notify-content-left">
        <img [src]="parseJson(data.data).sender_user.profile_image" alt="Profile Image" />
      </div>
      <div class="notify-content-right">
        <!-- <h1>{{parseJson(data.data).title}}</h1> -->
        <h1>{{data.req_type}}</h1>
        <p>{{ formatDate(parseJson(data.data).date) }}</p>
        <div class="notify-inner-sec">
          <h4>
            <span>{{ parseJson(data.data).sender_user.first_name }} {{
            parseJson(data.data).sender_user.last_name }}</span>
            had <span>{{ parseJson(data.data).title[0] }}</span> on {{
            formatOnlyDate(parseJson(data.data).date) }}.
          </h4>
        </div>
      </div>
      @if ( data.req_notifications[0].is_read == 0) {
        <div class="active-section">
          <div class="div-cirlce">
          </div>
        </div>
      }
    </div>
  }
</div>

</div>
</div>
</div>
</div>
</div>